import { createTechSpaceRooms } from "./index103.js";
import { DefaultModule, DefaultTechnicalSpace, RgCreate } from "@project-rouge/rg-core";
import { ResizeRgObj } from "@project-rouge/rg-three";
function createTechnicalSpaceForPodium({ building, space, includes, dataset }, size) {
	const fromRules = {
		data: {
			level: 0,
			levelId: "",
			muscleID: "",
			instance: space
		},
		name: space.name
	};
	let module = RgCreate({
		...DefaultModule,
		size,
		anchor: [
			.5,
			0,
			0
		],
		pos: [
			0,
			0,
			0
		],
		color: "#feffa3"
	}, dataset.rvData);
	module = ResizeRgObj({
		rgObj: module,
		useCache: false
	});
	const techSpace = RgCreate({
		...DefaultTechnicalSpace,
		...fromRules,
		size,
		anchor: [
			.5,
			0,
			0
		],
		children: [module]
	}, dataset.rvData);
	techSpace.data.level = 0;
	const techLevel = building.data.levels.find((l) => l.levelIndex === techSpace.data.level);
	techSpace.data.levelId = techLevel ? techLevel.uuid : "";
	techSpace.data.instance = space;
	techSpace.data.polygon = [
		[
			-size[0] * techSpace.anchor[0],
			0,
			0
		],
		[
			-size[0] * techSpace.anchor[0],
			0,
			size[2]
		],
		[
			size[0] * techSpace.anchor[0],
			0,
			size[2]
		],
		[
			size[0] * techSpace.anchor[0],
			0,
			0
		]
	];
	module.parent = techSpace;
	createTechSpaceRooms(techSpace, dataset, includes);
	return techSpace;
}
export { createTechnicalSpaceForPodium };

//# sourceMappingURL=index115.js.map